import {defineStore} from "pinia";
import Configuration from "@/configuration";

export const useSecurityStore = defineStore("security", {
    state: () => ({
        accessToken: null,
        userContext: {},
        authorities: {},
        version: null,
        serverAddress: null,
        serverPort: null,
        idControlProgram: null,
        idIssue: null,
        itemsToBeValidate: false,
        selectedModule: null,
        snackbar: false,
        refresh: null
    }),
    actions: {
        setRefresh() {
            const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let randomString = "";
            for (let i = 0; i < 10; i++) {
                const randomIndex = Math.floor(Math.random() * charset.length);
                randomString += charset[randomIndex];
            }
            this.refresh = randomString;
        },
        getImageLink() {
            return `${Configuration.value("rootApi")}/images`;
            // return `http://${this.serverAddress}:${this.serverPort}/images`
        },
        setAccessToken(accessToken) {
            this.accessToken = accessToken;
        },
        setUserContext(userContext) {
            this.userContext = userContext;
        },
        setAuthorities(authorities) {
            this.authorities = authorities;
        },
        setServerAddress(serverAddress) {
            this.serverAddress = serverAddress;
        },
        setServerPort(serverPort) {
            this.serverPort = serverPort;
        },
        setVersion(version) {
            this.version = version;
        },
        setSelectedModule(selectedModule) {
            this.selectedModule = selectedModule;
        },
        setControlProgram(idControlProgram) {
            this.idControlProgram = idControlProgram;
        },
        setIssue(idIssue) {
            this.idIssue = idIssue;
        },
        setItemsToBeValidate(itemsToBeValidate) {
            this.itemsToBeValidate = itemsToBeValidate;
        },
        setWorkerShowImage(show) {
            this.userContext.workerShowImage = show;
        }
    }
});
